export const PricingComparisonQuery = groq`
*[_type == "skosConceptScheme" &&  title=="Features"][0]{
    concepts[]-> {
      _id,
      prefLabel,
      definition,
      viewIn,
      broader[] {
       _ref
      }
    },
    topConcepts[]-> {
      _id,
      prefLabel,
      definition,
      viewIn,
      broader[] {
       _ref
      }
    },
}`;
